import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { InputItem } from "../../../components/forms/FormItems";
import FormActions from "../../../components/forms/FormActions";
import { DatePickerItem } from "../../../components/forms/FormItems";
import { Form, Button, Typography, Row, Col, Space } from "antd";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";
const { Title } = Typography;

const EditContract = (props) => {
  const { hide, addText, updateRecord, activeContract, loading } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      name: activeContract.name,
      description: activeContract.description,
      effective_to: activeContract.effective_to,
    });
  }, [activeContract]);

  const onFinish = async (values) => {
    let newVersion = {
      ...values,
      id: activeContract.id,
      effective_to: moment(values.effective_to).endOf("month").format(),
    };
    const action = await dispatch(updateRecord(newVersion));
    if (!action.error) {
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const disabledDate = (current) => {
    let isBeforeFromDate = false;
    activeContract.contract_versions.forEach((item, i) => {
      if (moment(item.effective_from) > moment(current)) {
        isBeforeFromDate = true;
      }
    });
    return current && isBeforeFromDate;
  };

  const onValuesChange = (values, all) => {
    let result = false;
    let required = ["name"];
    required.forEach((item, i) => {
      if (
        all[item] === undefined ||
        all[item] === "" ||
        all[item] === null ||
        all[item].length === 0
      ) {
        result = true;
      }
    });
    setDisabled(result);
  };

  const items = [
    {
      comp: <InputItem name="name" category="contract" required={true} />,
    },

    {
      comp: <InputItem name="description" category="contract" />,
    },
    {
      comp: (
        <DatePickerItem
          name="effective_to"
          category="contract"
          picker="month"
          format={"MM/YYYY"}
          disabledDate={disabledDate}
        />
      ),
    },
  ];

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <div>
      <div className="header" style={{ height: "40px" }}>
        <Button
          style={{ position: "absolute", left: 10, top: 10 }}
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={onDecline}
        />
      </div>
      <Title
        style={{
          fontSize: "30px",
          fontWeight: 500,
          lineHeight: 1.27,
          color: "rgba(0, 0, 0, 0.85)",
          margin: "13px 0 40px 0 ",
          textAlign: "center",
        }}
      >
        {addText}
      </Title>
      <Form
        {...layout}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
        form={form}
        style={{
          width: "100%",
        }}
      >
        <ChildrenAnimationWrapper>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Space size="middle">
              {items.map((item, i) => (
                <Col key={i} span={24} style={{ padding: "0 20px" }}>
                  <AnimationChildWrapper key={i} itemKey={i}>
                    {item.comp}
                  </AnimationChildWrapper>
                </Col>
              ))}
            </Space>
          </div>
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              <FormActions
                resource="organization.settings"
                action="editor"
                onCancel={onDecline}
                hideDelete={true}
                hideDecline={true}
                mode={"edit"}
                onDecline={onDecline}
                saveLoading={loading}
                category="tarrifsVersions"
                disabled={disabled}
              />
            </Col>
          </Row>
        </ChildrenAnimationWrapper>
      </Form>
    </div>
  );
};

EditContract.propTypes = {
  hide: PropTypes.func,
  visible: PropTypes.bool,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default EditContract;
